import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { Questionario } from './questionario.model';
import { DefaultFilter, DefaultServiceInterface } from './../../core/framework/default-service.interface';
import { ErrorHandlerService } from './../../core/framework/error-handler.service';
import { QuestionarioHealthmap, QuestionarioHealthmapFilter } from './integracao-healthmap/questionario.healthmap.model';
import { DefaultService } from 'src/app/core/framework/default-service';
import { QuestionarioDTO } from './../questionario/model/dto/questionario-dto.model';

export interface QuestionarioFilter extends DefaultFilter {
  
  id?: number;
  
  nome?: string;

  idQuestao?: number;
}

@Injectable({
  providedIn: 'root'
})
export class QuestionarioService extends DefaultService<Questionario> {

  static URL = '/api/questionario/v1/questionarios';

  constructor(
    public httpClient: HttpClient,
    public errorHandlerService: ErrorHandlerService
  ) {
    super(
      httpClient,
      errorHandlerService,
      QuestionarioService.URL
    );
  }

  inativarPorIdExterno(idExterno: string): Observable<string> {
    return this.httpClient.put<string>(`${QuestionarioService.URL}/inativarPorIdExterno/${idExterno}`, this.httpOptions)
                          .pipe(
                            catchError ( err => throwError(this.errorHandlerService.handle(err)) )
                          );
  }

  atualizar(id: number, questionario: Questionario): Observable<Questionario> {
    return this.httpClient.put<Questionario>(`${QuestionarioService.URL}/${id}`, questionario, this.httpOptions)
                          .pipe(
                            catchError ( err => throwError(this.errorHandlerService.handle(err)) )
                          );
  }

  converterParaFormQuestionarioDinamico(): Observable<any> {
    return null;
  }

  listarQuestionariosDoHealthmap(questionarioHealthmapFilter: QuestionarioHealthmapFilter): Observable<QuestionarioHealthmap[]> {
    const params = DefaultServiceInterface.converterFiltroParaHttpParam(questionarioHealthmapFilter);
    return this.httpClient.get<QuestionarioHealthmap[]>(`${QuestionarioService.URL}/listarQuestionariosHealthmap`, {params})
    .pipe(
      catchError ( err => throwError(this.errorHandlerService.handle(err)) )
    );
  }

  downloadQuestionarioHealthmap(codigoQuestionarioInternoDoHealthmap: string) {
    const params = DefaultServiceInterface.converterFiltroParaHttpParam({ codigoQuestionarioInternoDoHealthmap });
    return this.httpClient.get<QuestionarioHealthmap[]>(`${QuestionarioService.URL}/downloadQuestionarioHealthmap`, {params})
    .pipe(
      catchError ( err => throwError(this.errorHandlerService.handle(err)) )
    );
  }

  adicionarQuestao(idQuestionario: number, idQuestao: number): Observable<Questionario> {
    return this.httpClient.put<Questionario>(`${QuestionarioService.URL}/${idQuestionario}/adicionarQuestao/${idQuestao}`, {})
                          .pipe(
                            catchError ( err => throwError(this.errorHandlerService.handle(err)) )
                          );    
  }

  removerQuestao(idQuestionario: number, idQuestao: number): Observable<Questionario> {
    return this.httpClient.put<Questionario>(`${QuestionarioService.URL}/${idQuestionario}/removerQuestao/${idQuestao}`, {})
                          .pipe(
                            catchError ( err => throwError(this.errorHandlerService.handle(err)) )
                          );    
  }  

  atualizarOrdemQuestaoQuestionario(idQuestionario: number, idQuestao: number, ordem: number): Observable<any> {
    return this.httpClient.put<any>(`${QuestionarioService.URL}/${idQuestionario}/atualizarQuestao/${idQuestao}/paraOrdem/${ordem}`, {})
                          .pipe(
                            catchError ( err => throwError(this.errorHandlerService.handle(err, 'Trocar a ordem das questões falhou. Favor reabrir o questionário.')) )
                          );    
  }    

  atualiarSugerirEObrigatoriedade(idQuestionario: number, idQuestao: number, sugerir: boolean, obrigatorio: boolean): Observable<any> {
    const params = {
      sugerir,
      obrigatorio
    };

    return this.httpClient.put<any>(`${QuestionarioService.URL}/${idQuestionario}/atualizarQuestao/${idQuestao}/sugerirEObrigatoriedade`, params)
                          .pipe(
                            catchError ( err => throwError(this.errorHandlerService.handle(err, 'Trocar a ordem das questões falhou. Favor reabrir o questionário.')) )
                          );    
  }    

  fetchDTO(filter: QuestionarioFilter): Observable<QuestionarioDTO> {    
    const params = DefaultService.converterFiltroParaHttpParam(filter);
    return this.httpClient.get<QuestionarioDTO>(`${QuestionarioService.URL}/dto/${filter.id}`, {params})
               .pipe (
                 catchError (err => {
                    return throwError(this.errorHandlerService.handle(err));
                })
               );
  }
}
